import * as Color from "color"
import PptxGenJS, { Slide } from "pptxgenjs"
import { Decomposition } from "../debt-table"
import * as DebtUtils from "../utils"
import { ReportConfiguration } from "../../../configuration"
import { MasterSlide } from "../../pptx-configuration/master-slides"
import {
  Placeholder,
  getPlaceholderChartBodyOptions
} from "../../pptx-configuration/placeholders"
import { DocumentSection } from "../../types"
import { formatTitle } from "../../utils"
import { LoanWithDecomposition, LocalAuthority, Ppi, Scenario } from "../../../../../model"

export function checkInterestReimbursementSection(
  configuration: ReportConfiguration
): boolean {
  const interestReimbursement = configuration.debt.interestReimbursement
  return interestReimbursement.globalCharts || interestReimbursement.tables
}

export function createInterestReimbursementSection(
  pptx: PptxGenJS,
  configuration: ReportConfiguration,
  numbering: number[],
  decomposedLoans: LoanWithDecomposition[],
  years: number[],
  localAuthority:LocalAuthority,
  loans: any,
  scenario: Scenario,
  ppi?:Ppi
): DocumentSection {
  const slides: Slide[] = []
  const slidesTitle = formatTitle("Remboursement intérêts", numbering)
  const interestReimbursement = configuration.debt.interestReimbursement
  const placeholderBody = getPlaceholderChartBodyOptions()
  const baseColor = new Color(configuration.table.header.backgroundColor)

  if (interestReimbursement.tables) {
    DebtUtils.includeDebtTable(
      pptx,
      slidesTitle,
      "management-report-debt-interest-reimbursement",
      Decomposition.InterestReimbursement,
      decomposedLoans,
      years,
      configuration
    )
  }

  if (interestReimbursement.globalCharts) {
    const slide = pptx.addNewSlide(MasterSlide.Chart)

    slide.addText(slidesTitle, {
      placeholder: Placeholder.Title,
    })

    const chartData = DebtUtils.createChartData(
      Decomposition.InterestReimbursement,
      decomposedLoans,
      years,
      localAuthority,
      loans,
      scenario,
      ppi
    )

    const chartOptions = DebtUtils.createGlobalChartOptions(baseColor)

    slide.addChart(pptx.charts.BAR, chartData, chartOptions)

    slides.push(slide)
  }

  if (interestReimbursement.PieChartType) {
    const slide = pptx.addNewSlide(MasterSlide.Chart)

    slide.addText(slidesTitle, {
      placeholder: Placeholder.Title,
    })

    const pieChartData = DebtUtils.createPieChartData(
      decomposedLoans,
      "interest",
      configuration.generalities.referenceYear
    )

    const pieChartOptions = DebtUtils.createPieChartOptions(
      pieChartData,
      placeholderBody,
      baseColor
    )

    slide.addChart(pptx.charts.PIE, pieChartData, pieChartOptions)
    slides.push(slide)
  }

  if (interestReimbursement.perBank || interestReimbursement.perRateType) {
    const slide = pptx.addNewSlide(MasterSlide.Chart)

    slide.addText(slidesTitle, {
      placeholder: Placeholder.Title,
    })

    if (interestReimbursement.perBank) {
      const perBankChartData = DebtUtils.createPerBankChartData(
        decomposedLoans,
        "interest",
        configuration.generalities.referenceYear
      )

      const perBankChartOptions = DebtUtils.createPerBankChartOptions(
        perBankChartData,
        interestReimbursement.perRateType,
        placeholderBody,
        baseColor
      )

      slide.addChart(pptx.charts.PIE, perBankChartData, perBankChartOptions)
    }

    if (interestReimbursement.perRateType) {
      const perRateTypeChartData = DebtUtils.createPerRateTypeChartData(
        decomposedLoans,
        "interest",
        configuration.generalities.referenceYear
      )

      const perRateTypeChartOptions = DebtUtils.createPerRateTypeChartOptions(
        interestReimbursement.perBank,
        placeholderBody,
        baseColor
      )

      slide.addChart(
        pptx.charts.PIE,
        perRateTypeChartData,
        perRateTypeChartOptions
      )
    }

    slides.push(slide)
  }

  return { slides, title: slidesTitle }
}



// WEBPACK FOOTER //
// ./src/component/management-report/generator/debt-generator/interest-reimbursement-generator/index.tsx